(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
/* eslint-disable no-shadow */ function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.board = initialState || this.createEmptyBoard();
        this.score = 0;
        this.history = [];
        this.scoreHistory = [];
        this.undoCount = 2;
        this.shuffleCount = 1;
        this.removeCount = 0;
        this.has256 = false;
        this.has512 = false;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i].filter(function(val) {
                        return val !== 0;
                    });
                    for(var j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                        row[j] *= 2;
                        _this.score += row[j];
                        row[j + 1] = 0;
                        _this.checkWin(row[j]);
                        _this.checkUnlocks(row[j]);
                    }
                    var newRow = row.filter(function(val) {
                        return val !== 0;
                    });
                    while(newRow.length < _this.size)newRow.push(0);
                    if (_this.board[i].toString() !== newRow.toString()) moved = true;
                    _this.board[i] = newRow;
                };
                if (this.status !== "playing") return;
                this.savePreviousState();
                var moved = false;
                for(var i = 0; i < this.size; i++)_loop(i);
                if (moved) {
                    this.addRandomTile();
                    if (this.isGameOver()) this.status = "lose";
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.board = this.reverseRows(this.board);
                this.moveLeft();
                if (this.status === "win") return;
                this.board = this.reverseRows(this.board);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.board = this.transpose(this.board);
                this.moveLeft();
                if (this.status === "win") return;
                this.board = this.transpose(this.board);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.board = this.transpose(this.board);
                this.board = this.reverseRows(this.board);
                this.moveLeft();
                if (this.status === "win") return;
                this.board = this.reverseRows(this.board);
                this.board = this.transpose(this.board);
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status !== "playing") {
                    this.board = this.createEmptyBoard();
                    this.addRandomTile();
                    this.addRandomTile();
                    this.score = 0;
                    this.status = "playing";
                    this.undoCount = 2;
                    this.shuffleCount = 1;
                    this.removeCount = 0;
                    this.has256 = false;
                    this.has512 = false;
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.status = "idle";
                this.start();
            }
        },
        {
            key: "savePreviousState",
            value: function savePreviousState() {
                this.history.push(this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                }));
                this.scoreHistory.push(this.score);
                if (this.history.length > 2) {
                    this.history.shift();
                    this.scoreHistory.shift();
                }
            }
        },
        {
            key: "undo",
            value: function undo() {
                if (this.undoCount > 0 && this.history.length > 0) {
                    this.board = this.history.pop();
                    this.score = this.scoreHistory.pop();
                    this.undoCount--;
                }
            }
        },
        {
            key: "shuffle",
            value: function shuffle() {
                var _this = this;
                if (this.shuffleCount === 0) return;
                var flat = this.board.flat().filter(function(v) {
                    return v !== 0;
                });
                for(var i = flat.length - 1; i > 0; i--){
                    var j = Math.floor(Math.random() * (i + 1));
                    var ref;
                    ref = [
                        flat[j],
                        flat[i]
                    ], flat[i] = ref[0], flat[j] = ref[1], ref;
                }
                var newBoard = this.createEmptyBoard();
                flat.forEach(function(val, i) {
                    var row = Math.floor(i / _this.size);
                    var col = i % _this.size;
                    newBoard[row][col] = val;
                });
                this.board = newBoard;
                this.shuffleCount--;
            }
        },
        {
            key: "remove",
            value: function remove() {
                if (this.removeCount === 0) return;
                var filled = [];
                for(var i = 0; i < this.size; i++){
                    for(var j = 0; j < this.size; j++)if (this.board[i][j] !== 0) filled.push([
                        i,
                        j
                    ]);
                }
                if (filled.length === 0) return;
                var _filled_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(filled[Math.floor(Math.random() * filled.length)], 2), i1 = _filled_Math_floor[0], j1 = _filled_Math_floor[1];
                this.board[i1][j1] = 0;
                this.removeCount--;
            }
        },
        {
            key: "checkWin",
            value: function checkWin(value) {
                if (value === 2048) this.status = "win";
            }
        },
        {
            key: "checkUnlocks",
            value: function checkUnlocks(value) {
                if (value === 256 && !this.has256) {
                    this.shuffleCount++;
                    this.has256 = true;
                }
                if (value === 512 && this.removeCount < 2) {
                    this.removeCount++;
                    this.has512 = true;
                }
            }
        },
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var empty = [];
                for(var i = 0; i < this.size; i++){
                    for(var j = 0; j < this.size; j++)if (this.board[i][j] === 0) empty.push([
                        i,
                        j
                    ]);
                }
                if (empty.length > 0) {
                    var _empty_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empty[Math.floor(Math.random() * empty.length)], 2), i1 = _empty_Math_floor[0], j1 = _empty_Math_floor[1];
                    this.board[i1][j1] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                for(var i = 0; i < this.size; i++)for(var j = 0; j < this.size; j++){
                    if (this.board[i][j] === 0) return false;
                    if (j < this.size - 1 && this.board[i][j] === this.board[i][j + 1]) return false;
                    if (i < this.size - 1 && this.board[i][j] === this.board[i + 1][j]) return false;
                }
                return true;
            }
        },
        {
            key: "reverseRows",
            value: function reverseRows(matrix) {
                return matrix.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(_, colIndex) {
                    return matrix.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$boardElement = document.querySelector(".game-field");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$statusElement = document.querySelector(".message-lose");
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$toolsContainer = document.querySelector(".game-tools");
var $197cd56b15c33885$var$undoButton = document.querySelector(".undo-button");
var $197cd56b15c33885$var$shuffleButton = document.querySelector(".shuffle-button");
var $197cd56b15c33885$var$removeButton = document.querySelector(".remove-button");
function $197cd56b15c33885$var$updateToolButtons() {
    var updateSlots = function(button, count, max) {
        var slots = Array.from(button.querySelectorAll(".use-slot"));
        slots.forEach(function(slot, index) {
            slot.classList.toggle("used", index < count);
        });
        button.disabled = count === 0;
    };
    updateSlots($197cd56b15c33885$var$undoButton, $197cd56b15c33885$var$game.undoCount, 2);
    updateSlots($197cd56b15c33885$var$shuffleButton, $197cd56b15c33885$var$game.shuffleCount, 2);
    updateSlots($197cd56b15c33885$var$removeButton, $197cd56b15c33885$var$game.removeCount, 2);
}
function $197cd56b15c33885$var$render() {
    var state = $197cd56b15c33885$var$game.getState();
    // eslint-disable-next-line no-shadow
    var status = $197cd56b15c33885$var$game.getStatus();
    var cells = $197cd56b15c33885$var$boardElement.querySelectorAll(".field-cell");
    cells.forEach(function(cell, index) {
        var row = Math.floor(index / 4);
        var col = index % 4;
        var value = state[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value > 0) cell.classList.add("field-cell--".concat(value));
    });
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    switch(status){
        case "win":
            $197cd56b15c33885$var$statusElement.textContent = "You win!";
            $197cd56b15c33885$var$statusElement.classList.remove("hidden");
            break;
        case "lose":
            $197cd56b15c33885$var$statusElement.textContent = "You lose! Restart the game?";
            $197cd56b15c33885$var$statusElement.classList.remove("hidden");
            break;
        default:
            $197cd56b15c33885$var$statusElement.classList.add("hidden");
    }
    $197cd56b15c33885$var$updateToolButtons();
}
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var keyActions = {
        ArrowLeft: function() {
            return $197cd56b15c33885$var$game.moveLeft();
        },
        ArrowRight: function() {
            return $197cd56b15c33885$var$game.moveRight();
        },
        ArrowUp: function() {
            return $197cd56b15c33885$var$game.moveUp();
        },
        ArrowDown: function() {
            return $197cd56b15c33885$var$game.moveDown();
        }
    };
    var action = keyActions[e.key];
    if (action) {
        action();
        $197cd56b15c33885$var$render();
    }
});
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    var isIdle = $197cd56b15c33885$var$game.getStatus() === "idle";
    if (isIdle) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$toolsContainer.classList.remove("hidden");
    } else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$undoButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.undo();
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$shuffleButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.shuffle();
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$removeButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.remove();
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=index.3805a78b.js.map
